import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMutation } from 'react-query';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import { PopularProductForm } from 'components/Forms/PopularProductForm/PopularProductForm';
import { popularProductsTranslations } from 'containers/PopularProducts/translations';
import { PopularProductsTransFields } from 'containers/PopularProducts/types';
import styles from './popularProduct.module.scss';
import { AppLoader } from 'components/Core/AppLoader';

const PopularProduct: FC = () => {
  const {
    popularProductsStore: { popularProductData, getPopularProductData },
  } = useStore();

  const { t } = useMyTranslations<PopularProductsTransFields>([popularProductsTranslations.name]);

  const { id } = useParams();
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation(getPopularProductData, {
    mutationKey: 'getPopularProductData',
    onError: () => navigate('/popular-products'),
  });

  useEffect(() => {
    !popularProductData && id && mutate(id);
  }, [id, popularProductData]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t(id ? 'titleEdit' : 'titleAdd')}</h2>
      </header>
      <div className={styles.container}>{isLoading ? <AppLoader /> : <PopularProductForm />}</div>
    </main>
  );
};

export default observer(PopularProduct);
